import { combineReducers, configureStore } from "@reduxjs/toolkit";
import * as Sentry from "@sentry/react";

import createNewDoctorReducer from "../features/createnewdoctor/createNewDoctorSlice";
import dashboardDataReducer from "../features/dashboardData/dashboardDataSlice";
import editDoctorReducer from "../features/editdoctordata/editDoctorsDataSlice";
import assignReducer from "../features/feed/assignSlice";
import feedReducer from "../features/feed/feedSlice";
import pearlSliceReducer from "../features/feed/pearlSlice";
import tipSliceReducer from "../features/feed/tipSlice";
import filesReducer from "../features/files/filesSlice";
import loginReducer from "../features/login/loginSlice";
import profileReducer from "../features/profile/profileSlice";
import programsReducer from "../features/programs/programsSlice";
import programAssignmentReducer from "../features/programs/programAssignmentSlice";
import pscReducer from "../features/psc/pscSlice";
import reportsReducer from "../features/reports/reportsSlice";
import settingsReducer from "../features/settings/settingsSlice";
import sidebarReducer from "../features/sidebar/sidebarSlice";
import tournamentsReducer from "../features/tournaments/tournamentSlice";
import userReducer from "../features/users/usersSlice";
import usersSummaryReducer from "../features/users_summary/usersSummarySlice";
import sensorDataSlice from "../features/sensor/sensorData";
import surveyQuestionSlice from "../features/survey/questions/surveyQuestionSlice";
import surveyModuleSlice from "../features/survey/modules/surveyModuleSlice";
import surveyAssignmentSlice from "../features/survey/assignment/surveyAssignmentSlice";

const rootReducer = combineReducers({
  profile: profileReducer,
  login: loginReducer,
  sidebar: sidebarReducer,
  createNewDoctor: createNewDoctorReducer,
  users: userReducer,
  usersSummary: usersSummaryReducer,
  dashboardData: dashboardDataReducer,
  editdoctor: editDoctorReducer,
  reports: reportsReducer,
  files: filesReducer,
  settings: settingsReducer,
  programs: programsReducer,
  programAssignment: programAssignmentReducer,
  feed: feedReducer,
  tournaments: tournamentsReducer,
  psc: pscReducer,
  pearls: pearlSliceReducer,
  tips: tipSliceReducer,
  assign: assignReducer,
  sensor: sensorDataSlice,
  surveyQuestion: surveyQuestionSlice,
  surveyModule: surveyModuleSlice,
  surveyAssignment: surveyAssignmentSlice,
});

const sentryReduxEnhancer = Sentry.createReduxEnhancer({
  configureScopeWithState: (scope, state) => {
    if (state.profile.userProfile?.email) {
      const userProfile = state.profile.userProfile;
      Sentry.setUser({
        email: userProfile?.email,
        id: userProfile?.user_id,
      });
      scope.setTag("user.phoneNo", userProfile?.phone_no);
      scope.setTag("user.customer", userProfile?.customer);
      scope.setTag("user.type", userProfile?.type);
    }
  },
});

export const setupStore = (preloadedState) => {
  return configureStore({
    reducer: rootReducer,
    preloadedState,
    enhancers: [sentryReduxEnhancer],
  });
};
